.vitrin-izgarasi {
  min-width: 0;
}
.vitrin-karti {
  position: relative;
  min-width: 0;
  height: 100%;
  overflow: hidden;
  border: 1px solid var(--renk-cizgi);
  border-radius: 12px;
  background: var(--renk-beyaz);
  color: var(--renk-murekkep);
}
.vitrin-karti-baglantisi {
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 100%;
  color: inherit;
  transition: transform 100ms ease-out;
}
.vitrin-karti-baglantisi:active {
  transform: scale(0.99);
}
.vitrin-karti-gorseli {
  position: relative;
  flex-shrink: 0;
  width: 100%;
  aspect-ratio: 1.32;
  overflow: hidden;
  background: var(--renk-acik);
}
.vitrin-karti-rozet {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 3px 8px;
  border-radius: 5px;
  background: var(--renk-sari);
  color: var(--renk-vurguYazi);
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
}
.vitrin-karti-icerigi {
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  gap: 4px;
  padding: 14px;
}
.vitrin-karti-etiketler {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}
.vitrin-karti-etiket {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 5px;
  border-radius: 4px;
  background: var(--renk-acik);
  color: var(--renk-gri);
  font-size: 10px;
  line-height: 16px;
}
.vitrin-karti-basligi {
  display: -webkit-box;
  min-height: 40px;
  margin: 0;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.2px;
  overflow-wrap: anywhere;
}
.vitrin-karti-fiyati {
  margin: 0 0 7px;
  font-size: 21px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: -0.6px;
  overflow-wrap: anywhere;
}
.vitrin-karti-konumu {
  display: flex;
  align-items: center;
  gap: 3px;
  padding-top: 9px;
  border-top: 1px solid var(--renk-cizgi);
  color: var(--renk-gri);
}
.vitrin-karti-konum-adi {
  display: flex;
  flex: 1;
  align-items: center;
  gap: 3px;
  min-width: 0;
  font-size: 11px;
  line-height: 17px;
}
.vitrin-karti-konum-adi svg {
  flex-shrink: 0;
}
.vitrin-karti-konum-adi > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vitrin-karti-zamani {
  flex-shrink: 0;
  font-size: 10px;
  line-height: 16px;
  white-space: nowrap;
}
.vitrin-karti-favori {
  position: absolute;
  top: 9px;
  right: 9px;
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: var(--renk-beyaz);
  color: var(--renk-murekkep);
  cursor: pointer;
  transition: transform 100ms ease-out;
  -webkit-tap-highlight-color: transparent;
}
.vitrin-karti-favori::after {
  position: absolute;
  inset: -6px;
  content: '';
}
.vitrin-karti-favori:active {
  transform: scale(0.94);
}
.vitrin-karti-favori[aria-pressed='true'] {
  background: var(--renk-sari);
  color: var(--renk-vurguYazi);
}
@media (prefers-reduced-motion: no-preference) {
  .vitrin-karti-favori[aria-pressed='true'] > svg {
    animation: kacakcidan-favori 260ms ease-out;
  }
}
@media (prefers-reduced-motion: reduce) {
  .vitrin-karti-baglantisi,
  .vitrin-karti-favori {
    transform: none !important;
    transition: none;
  }
}
